import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-5xl md:text-6xl font-bold mb-12 text-center">{t.about.title}</h1>

        {/* Artist Statement */}
        <section className="mb-16 bg-white rounded-lg p-8 shadow-sm">
          <h2 className="text-3xl font-bold mb-6 border-b-2 border-black pb-2 inline-block">
            {t.about.statement}
          </h2>
          <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
            <p>{t.about.statementText}</p>
            <p>{t.about.statementText2}</p>
            <p>{t.about.statementText3}</p>
          </div>
        </section>

        {/* Process & Materials */}
        <section className="mb-16 bg-white rounded-lg p-8 shadow-sm">
          <h2 className="text-3xl font-bold mb-6 border-b-2 border-black pb-2 inline-block">
            {t.about.process}
          </h2>
          <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
            <p>{t.about.processText}</p>
            <p>{t.about.processText2}</p>
          </div>
        </section>

        {/* Biography */}
        <section className="mb-16 bg-white rounded-lg p-8 shadow-sm">
          <h2 className="text-3xl font-bold mb-6 border-b-2 border-black pb-2 inline-block">
            {t.about.bio}
          </h2>
          <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
            <p>{t.about.bioText}</p>
            <p className="font-semibold text-gray-900">{t.about.seeking}</p>
          </div>
        </section>

        {/* Education */}
        <section className="bg-white rounded-lg p-8 shadow-sm">
          <h2 className="text-3xl font-bold mb-6 border-b-2 border-black pb-2 inline-block">
            {t.about.education}
          </h2>
          <div className="space-y-4 text-lg text-gray-700">
            <div>
              <p className="font-semibold text-gray-900">2020</p>
              <p>Bachelor Web Marketing & Sales Manager (France)</p>
            </div>
            <div>
              <p className="font-semibold text-gray-900">2013</p>
              <p>Bachelor Graphic Design (University of Technical Arts - Paris, France)</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
